import * as Sentry from "@sentry/react";
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorBoundaryFallback from './ErrorBoundaryFallback';

const AppErrorBoundary = ({
    children
}) => {
    return (
        <ErrorBoundary
            FallbackComponent={ErrorBoundaryFallback}
            onReset={Sentry.showReportDialog}
        >
            {children}
        </ErrorBoundary>
    )
}

export default AppErrorBoundary
